import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import BaseLayout from '@Components/BaseLayout';
import SsoCallback from '@Components/SsoCallback';
import { getBasename } from '@Utils/commonUtils';

const Routes = () => {
    const historyInstance = createBrowserHistory();
    return (
        <Router history={historyInstance} basename={`${getBasename()}`}>
            <Switch>
                <Route exact path="/login" component={SsoCallback} />
                <Route path="/" component={BaseLayout} />
            </Switch>
        </Router>
    );
};

export default Routes;
